import {
    TextField,
    FormControl,
    Typography,
    FormControlLabel,
    Switch,
    Grid,
    Divider
} from "@mui/material";
import React from "react";
import { isMbxUserMbxAdmin } from "../../atoms/atoms";
import { useAtom } from "jotai";
import InfoTooltip from "../../utils/UI/InfoTooltip";

function ProvidersTab({
    bookingStates,
    bookingStatesChangeHandler,
    providerMustAcceptAppt
}) {
    const [isMbAdminLoggedIn] = useAtom(isMbxUserMbxAdmin);
    return (
        <>
            <Grid item variant="subHeading">
                <Typography variant="largerSubHeading">Providers</Typography>
            </Grid>
            <Grid item variant={"subHeading-divider"}>
                <Divider />
            </Grid>
            <Grid item xs={12} sm={12}>
                <FormControlLabel
                    control={
                        <Switch
                            name={"displayProviderRatings"}
                            checked={bookingStates.displayProviderRatings}
                            onChange={bookingStatesChangeHandler}
                            color="primary"
                        />
                    }
                    label="Display provider ratings"
                />
                <InfoTooltip
                    title={
                        "Always shown to logged in admins and managers, even if off"
                    }
                />
            </Grid>
            <Grid item xs={12} sm={12}>
                <FormControlLabel
                    control={
                        <Switch
                            checked={
                                providerMustAcceptAppt
                                    ? bookingStates.showProviderAcceptance
                                    : false
                            }
                            onChange={bookingStatesChangeHandler}
                            name={"showProviderAcceptance"}
                            color="primary"
                            disabled={!providerMustAcceptAppt}
                        />
                    }
                    label="Display provider acceptance rates and response times"
                />
                <InfoTooltip
                    title={
                        "Always shown to logged in admins and managers, even if off"
                    }
                />
            </Grid>
            <Grid item xs={12} sm={12}>
                <FormControlLabel
                    control={
                        <Switch
                            checked={bookingStates.useAnonymousPermalink}
                            onChange={bookingStatesChangeHandler}
                            name={"useAnonymousPermalink"}
                            color="primary"
                            disabled={!isMbAdminLoggedIn}
                        />
                    }
                    label="Anonymize provider permalinks"
                />
                <InfoTooltip
                    title={
                        <Typography variant="body1">
                            Provider permalinks are generated by default as
                            .../firstname-lastname – if anonymized, they will
                            instead be generated as .../firstname-[number] –
                            please contact our{" "}
                            <a
                                href="mailto:support@gomarketbox.com"
                                target="_blank"
                                rel="noreferrer"
                                style={{
                                    color: "white",
                                    textDecoration: "underline"
                                }}
                            >
                                support team
                            </a>{" "}
                            to change this setting or to update any exising
                            permalink URLs
                        </Typography>
                    }
                />
            </Grid>
            <Grid container item xs={12} sm={12} gap={0.5}>
                <Grid container item xs={12} sm={12}>
                    <FormControl required fullWidth>
                        <TextField
                            variant="outlined"
                            InputProps={{
                                disableUnderline: true
                            }}
                            size="small"
                            multiline
                            rows={2}
                            label="No available providers message"
                            name={"noProviderMessage"}
                            value={bookingStates.noProviderMessage}
                            onChange={bookingStatesChangeHandler}
                        />
                    </FormControl>
                </Grid>
                <Grid container item xs={12} sm={12}>
                    <InfoTooltip
                        title={
                            "Shown to clients if there are no available providers for the selected service in their area"
                        }
                    />
                </Grid>
            </Grid>
        </>
    );
}

export default ProvidersTab;
